// extracted by mini-css-extract-plugin
export default {"block":"styles_block__AJxNw","address":"styles_address__aegqi","appear":"styles_appear__JBjsB"};